import axios from 'axios'
import VueInstance from '@/main'

export default {
  namespaced: true,
  state: {
    allUsers: [],
    adminConsoleUsers: [],
    user: {}
  },

  getters: {
    getUser: state => {
      if (!state.user.id) {
        state.user = VueInstance.$auth.getUser()
      }
      return state.user
    }
  },

  mutations: {
    setUsers (state, users) {
      state.allUsers = users
    },

    setAdminConsoleUsers (state, adminConsoleUsers) {
      state.adminConsoleUsers = adminConsoleUsers
    }
  },

  actions: {
    /**
     * Fetches all the users
     */
    async fetchAllUsers ({ commit }) {
      try {
        const users = (await axios.get(`${process.env.VUE_APP_API_URI}/users`)).data
        commit('setUsers', users)
      } catch (error) {
        console.error(`Error while fetching all users to store: ${error}`)
        throw error
      }
    },

    /**
     * Fetches admin console users
     */
    async fetchAdminConsoleUsers ({ commit }) {
      const adminConsoleUsers = (await axios.get(`${process.env.VUE_APP_API_URI}/admin-console/admin-users`)).data
      commit('setAdminConsoleUsers', adminConsoleUsers)
    }
  }
}
